import styled from "styled-components";
import type { IButtonProps } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";
import { colorsPalettes, mixins } from "@similarweb/styles";

export const DomainInfoButton = styled(IconButton)`
    transition: none;
    .SWReactIcons svg path:first-of-type {
        fill: ${({ isDisabled }: IButtonProps) => (!isDisabled ? `${colorsPalettes.blue[400]}` : null)};
    }
    &:hover {
        .SWReactIcons svg path:first-of-type {
            fill: ${({ isDisabled }: IButtonProps) => (!isDisabled ? `${colorsPalettes.blue[500]}` : null)};
        }
    }
    & span {
        ${mixins.setFont({ $size: 14, $weight: 700 })}
    }
`;

export const DomainInfoContainer = styled.div`
    div span {
        text-transform: none;
    }
`;
